/**
 * I-1138: the native More drawer's embedded navigation is its own small web view at
 * `/-/more?panel=nav` (`MoreMenuDrawer`, `ensureMorePanelScreen`). It shows the navigation and
 * nothing else: the screen behind it already carries every top bar (the ungated-preview banner, the
 * maintenance and account notices), and one drawn in the panel lands between its rows.
 *
 * Read from the address, never from React state: the panel view is loaded at this address and stays
 * there, and the bars above the router have no router to ask.
 */
export function isDrawerPanelView(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('panel') === 'nav';
}
